import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
  dropdownContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: '8px',
  },
  dialogPaper: {
    overflow: 'visible',
  },
  dialogContent: {
    overflow: 'visible',
  },
  separator: {
    height: '1px',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    margin: '8px 0',
  },
});
